import { CommonModule } from '@angular/common';
import { LocalizationService, SubscriptionService, LocalizationModule } from '@abp/ng.core';
import { Component, Injector, OnInit } from '@angular/core';
import { DwGridDataSourceService, FieldTypes } from '@digiwall/ag-grid';
import { ColDef } from '@ag-grid-community/core';
import {
  CustomerReturnNoteListDto,
  CustomerReturnNoteService,
} from '@digiwall/goliath-documents/proxy';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfirmationService } from '@abp/ng.theme.shared';
import { BaseCustomerDocList } from '../../base-customer-docs/base-customer-doc-list';
import { ListPageComponent } from '@digiwall/ag-grid';
import { AgGridComponent } from '@digiwall/ag-grid';

@Component({
  selector: 'document-customer-return-note-list',
  templateUrl: './customer-return-note-list.component.html',
  styles: `
    :host {
      flex-grow: 1;
    }
  `,
  providers: [DwGridDataSourceService, SubscriptionService],
  imports: [CommonModule, ListPageComponent, AgGridComponent, LocalizationModule],
})
export class CustomerReturnNoteListComponent
  extends BaseCustomerDocList<CustomerReturnNoteListDto, CustomerReturnNoteService>
  implements OnInit
{
  private _columns: ColDef[] = [
    ...this.colDefs,
    {
      field: 'returnReceivedDate',
      headerName: this.localizationService.instant('Doc::CustomerReturnNote:ReturnReceivedDate'),
      type: FieldTypes.Date,
    },
    {
      field: 'isCredited',
      headerName: this.localizationService.instant('Doc::CustomerReturnNote:IsCredited'),
      type: FieldTypes.Boolean,
    },
  ];

  get columns(): ColDef[] {
    return this._columns;
  }

  constructor(
    customerReturnNoteService: CustomerReturnNoteService,
    router: Router,
    route: ActivatedRoute,
    localizationService: LocalizationService,
    subscriptionService: SubscriptionService,
    confirmation: ConfirmationService,
    datasource: DwGridDataSourceService,
    injector: Injector,
  ) {
    super(
      customerReturnNoteService,
      router,
      route,
      localizationService,
      subscriptionService,
      confirmation,
      datasource,
      injector,
    );
  }
}
